export default function IosPieOutline() {
  return (
    <div
      className="ion-icon-ios-pie-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M288,80.826c45.293,3.705,87.354,23.024,119.809,55.494C444.044,172.57,464,220.744,464,272.043
		c0,25.924-5.08,51.042-15.099,74.703c-9.68,22.859-23.54,43.384-41.194,61.024c-17.654,17.639-38.204,31.481-61.08,41.151
		c-23.673,10.01-48.823,15.081-74.752,15.081c-41.193,0-80.47-12.847-113.584-37.146c-15.95-11.705-29.957-25.733-41.633-41.692
		c-8.378-11.453-15.422-23.724-21.041-36.634l180.259-45.008L288,300.496V288V81 M272,64v224L74.245,337.376
		C101.653,420.221,179.841,480,271.875,480C386.75,480,480,386.875,480,272S387,64,272,64L272,64z"/>
	<path d="M240,48.181v214.943L59.658,308.854c-9.117-23.568-11.197-56.973-11.158-69.496v-0.036v-0.035
		c0-47.311,16.465-93.746,45.173-127.398c16.735-19.618,37.502-34.981,61.721-45.663C180.099,55.331,208.519,49.274,240,48.181
		 M256,32h-5.5C90.5,32,32,148.25,32,239.287c0,0,0.25,56.666,18.91,88.291L256,275.573V32L256,32z"/>
</g>
</svg>
`,
      }}
    />
  )
}
